/**
 * 可以在此地扩展vue方法 以便你更好的使用它
 */
const fine = {
    $calcHeight: () => {
        // const $ = window.$;
        // const calcHeight = $('.vue-app').height() - $('.header').height();
        // $('.drizzle-content').height(calcHeight);
    },
    // 切换到drizzlejs框架，隐藏vue框架后的回调
    $vueHided() {
        // 移除个人中心模块的全局样式
        window.$('body').removeClass('mix-vue-center');
        // 移除vue模块的全局样式
        window.$('body').removeClass('mix-vue');
    },
    // 修复ant-select-dropdown 选中状态显示有误 bug号：83693...
    $fixDropdown() {
        setTimeout(() => {
            window.jQuery('.ant-select-dropdown-menu-item').removeClass('ant-select-dropdown-menu-item-active');
        }, 0);
    },
    $safeOptions() {
        // 地址栏安全处理
        return window.zxyDrizzle.global.rateMethods.getInfo({
            live: window.location.hash,
            id: window.location.hash.replace(/#\/live\/(detail|lecturer|preview|action)\//g, '').split('/')[0]
        }, 'live', 'id');
    }
};

const useful = {
    install(Vue) {
        Object.keys(fine).forEach((key) => {
            Vue.prototype[key] = fine[key];
        });
    }
};

export default useful;
